//BFSG
import * as React from 'react'
import * as t from './types'
import styled from 'styled-components'
import withDy from './withDy'
import { theme } from 'containers/GlobalStyle'
import { ReactComponent as LinkArrow } from 'assets/arrow-button-right.svg'
import Link from 'theme/atoms/Link'
import IconDisplayer from './IconDisplayer'
import usePersonalization from 'hooks/usePersonalization'
import EecTracking from 'theme/atoms/EecTracking'

export default withDy(function SnackableTeaser(props: t.Props) {
  const iconSelected = props.Icon
  const personalization = usePersonalization()

  return (
    <EecTracking config={props.eecTracking} gridArea="Notification-Bar">
      <Wrapper
        className="SnackableTeaser"
        data-cy-ctx="organisms/SnackableTeaser"
        data-cy-handle="teaser-click"
        to={props.Link}
        onClick={() => personalization.trackClick()}
        $backgroundColor={props.backgroundColor || theme.colors.brand.lusini}
        $textColor={props.textColor || theme.colors.black}
      >
        <div className="teaser-container">
          <div className="icon-wrapper">
            <Icon32 icon={iconSelected} />
            <div className="headline">
              <span className="headline-desktop">{props.Headline_desktop}</span>
              <span className="headline-mobile">{props.Headline_mobile}</span>
            </div>
          </div>

          {props.Linktext && (
            <LinkWrapper data-cy-state="teaser-link">
              {props.Linktext}
              <LinkArrow24 />
            </LinkWrapper>
          )}
        </div>
      </Wrapper>
    </EecTracking>
  )
})
const Wrapper = styled(Link)<{
  $backgroundColor: string
  $textColor: string
}>`
  width: 100%;
  background-color: ${(teaser_container) => teaser_container.$backgroundColor};
  color: ${(teaser_container) => teaser_container.$textColor};
  display: block;

  /* Icon color styling - covers multiple SVG structures */
  svg {
    fill: ${(p) => p.$textColor};
    color: ${(p) => p.$textColor};
    
    * {
      fill: ${(p) => p.$textColor};
    }
    
    path {
      fill: ${(p) => p.$textColor};
    }
    
    g {
      fill: ${(p) => p.$textColor};
      stroke: ${(p) => p.$textColor};
    }
  }

  > .teaser-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    min-height: 4rem;
    padding: ${theme.spacing('xs')} ${theme.spacing('s')};
    > .teaser-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      > h3 {
        ${theme.ty('rc-l')}
        margin: ${theme.spacing('s')} 0;
      }

      > p {
        ${theme.ty('r-base')}
        margin: ${theme.spacing('s')} 0;
      }
    }

    > .icon-wrapper {
      display: flex;
      align-items: center;
      gap: ${theme.spacing('xs')};
      width: 100%;
      
      > .headline {
        ${theme.ty('rc-xl')}
        text-align: left;
        color: ${(teaser_container) => teaser_container.$textColor};
        font-weight: ${theme.ty('r-2xl')};
        
        > .headline-desktop {
          display: none;
        }
        > .headline-mobile {
          display: block;
        }
        @media (min-width: ${theme.ms.MD}px) {
          > .headline-desktop {
            display: block;
          }
          > .headline-mobile {
            display: none;
          }
        }
      }
    }
    @media (min-width: ${theme.ms.MD}px) {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
  }
`

const Icon32 = styled(IconDisplayer)`
  width: 2rem;
  height: 2rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  
  
  @media (min-width: ${theme.ms.MD}px) {
    margin-right: ${theme.spacing('xs')};
  }
`

const LinkWrapper = styled.div`
  ${theme.ty('rc-base', 'bold')}
  font-size: 14px;
  display: flex;
  align-items: center;
  margin-top: ${theme.spacing('xs')};
  margin-left: calc(2rem + ${theme.spacing('xs')});
  
  @media (min-width: ${theme.ms.MD}px) {
    margin-top: auto;
    margin-bottom: auto;
    margin-left: 0;
  }
`

const LinkArrow24 = styled(LinkArrow)`
  width: 1em;
  height: 1em;
  margin-left: ${theme.spacing('xs')};
`
